/*---------- Open All External Links in New Tab ----------*/

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

/*---------- Cart ----------*/


var coll = document.getElementsByClassName("cart-flow-collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}


// Auto Select Dealer.
const urlParams = new URLSearchParams(window.location.search);
const dealer_param = urlParams.get('dealer');

(function() {
  if(dealer_param) {
    const select = document.querySelector('#select-dealer');
    const dealer_array = [...select.options].map(a => a.value)
    if(dealer_array.includes(dealer_param) || dealer_param === "PROMOTION") {
      select.value = dealer_param;
    }
  }
})();

(function() {
  const cartForm = document.querySelector('#CartPageForm');
  
  cartForm.addEventListener('submit', validateDealer);

  cartForm.querySelector('button[type=submit][name=checkout]').addEventListener('click', validateDealer);
  cartForm.querySelector('button[type=submit][name=checkout]').addEventListener('mousedown', validateDealer);
  cartForm.querySelector('button[type=submit][name=checkout]').addEventListener('touchstart', validateDealer);
  
  function validateDealer(e) {
    const select = document.querySelector('#select-dealer');
    const selectedValue = select.options[select.selectedIndex].value;
    console.log(selectedValue);
    
    if (!selectedValue.length) {
      e.preventDefault();
      e.stopPropagation();
      alert("Please Select A Dealer To Continue.");
    }
  }
})();